import * as React from "react";
import { ImagesContext } from "../Context";

interface Props {
  customMessage?: any;
}

const LoadingTable: React.FC<Props> = (props: any) => {
  const images = React.useContext(ImagesContext);

  return (
    <div className="loading-container">
      <img src={images.new_large_spinner_src}></img>
      <h3>Loading...</h3>
      <p>
        We are loading your patients list.
        <br />
        This might take a few miniutes. Please do not leave this
        page.
      </p>
    </div>
  );
};

export default LoadingTable;
